import { useQuery } from "@tanstack/react-query";

import { companyMachinesQuery } from "#modules/machines/infra/companyMachines.query";

export const useCompanyMachines = () => {
  const { data, ...rest } = useQuery({ ...companyMachinesQuery() });

  return { companyMachines: data ?? [], ...rest };
};
